/**
 * 基于角色的访问控制（简化版）
 * @see https://umijs.org/docs/max/access
 *
 * 角色：admin 管理员 | sales 业务员 | checker 收发员 | warehouse 库管 | finance 财务 | factory 厂长
 */
export default function access(
  initialState: { currentUser?: API.CurrentUserInfo } | undefined,
) {
  const role = initialState?.currentUser?.role || '';

  // 仓储：产品 = 库存/流水 多人可见；原材料 = 仅厂长/管理员；原材料出入库操作 = 仅管理员
  const canSeeWarehouseAny = [
    'sales',
    'checker',
    'warehouse',
    'finance',
    'factory',
    'admin',
  ].includes(role);
  const canSeeProduct = ['sales', 'checker', 'warehouse', 'admin'].includes(
    role,
  );
  const canOperateProduct = ['warehouse', 'admin'].includes(role);
  const canSeeMaterial = ['factory', 'admin'].includes(role);
  const canOperateMaterial = role === 'admin';
  const canSubmitOutbound = ['factory', 'admin'].includes(role);
  const canReverseFlow = ['warehouse', 'admin'].includes(role);

  return {
    canAdmin: role === 'admin',
    canReverseFlow,

    canSeeSales: ['sales', 'checker', 'warehouse', 'finance', 'admin'].includes(
      role,
    ),

    canSeeProduction: ['sales', 'factory', 'admin'].includes(role),
    canSeeProductionOrders: ['sales', 'factory', 'admin'].includes(role),
    canCreateProductionOrder: ['sales', 'factory', 'admin'].includes(role),

    // 仓储菜单（有任一项子权限即显示）
    canSeeWarehouse: canSeeWarehouseAny,
    // 产品库存、产品流水：业务员/收发/库管/财务/厂长/管理员
    canSeeWarehouseProductStock: canSeeProduct,
    canSeeWarehouseProductLedger: canSeeWarehouseAny,
    // 产品入库/出库/盘点：仅库管/管理员
    canSeeWarehouseProductInOut: canOperateProduct,
    // 原材料库存、原材料流水：仅厂长/管理员
    canSeeWarehouseMaterialStock: canSeeMaterial,
    canSeeWarehouseMaterialLedger: canSeeMaterial,
    // 原材料入库：仅管理员；原材料出库提交：厂长/管理员
    canOperateMaterialInbound: canOperateMaterial,
    canSubmitMaterialOutbound: canSubmitOutbound,
    canSeeWarehousePurchase: role === 'admin',

    // 基础资料菜单（有任一项子权限即显示）
    canSeeMaster: ['sales', 'factory', 'finance', 'admin'].includes(role),
    // 产品：业务员/财务/厂长/管理员
    canSeeMasterProducts: ['sales', 'factory', 'finance', 'admin'].includes(
      role,
    ),
    // 原材料：管理员/厂长/财务
    canSeeMasterMaterials: ['admin', 'factory', 'finance'].includes(role),
    // 供应商：管理员/财务
    canSeeMasterSuppliers: ['admin', 'finance'].includes(role),
    // 客户：业务员/管理员/财务
    canSeeMasterCustomers: ['sales', 'admin', 'finance'].includes(role),
    // 新增客户：业务员/管理员
    canCreateCustomer: ['sales', 'admin'].includes(role),

    canSeeSystem: role === 'admin',
  };
}
